export const ioTypes = {
    MOLECULE: 'molecule',
    ENZYME: 'enzyme',
}
